// extracted by mini-css-extract-plugin
export default {"status_container":"UserServiceConfiguration_status_container__qVI13","status":"UserServiceConfiguration_status__KQnww"};